import {getheaders} from "./authService";

export async function getAllWebhookConnections() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch("/api/guesty/webhook", requestOptions);
}

export async function getWebhookConnectionByCustomerId(cosCustomerId) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch(`/api/guesty/webhook?cosCustomerId=${cosCustomerId}`, requestOptions);
}

export async function upsertWebhookConnection(webhookData) {
    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(webhookData)
    };

    return fetch("/api/guesty/webhook/upsert", requestOptions);
}

export async function deleteWebhookConnection(cosCustomerId, webhookId) {
    let requestOptions = {
        method: 'DELETE',
        headers: getheaders(),
        redirect: 'follow'
    };

    // If webhookId is provided, delete a specific webhook
    // Otherwise, delete all webhooks for the customer (backward compatibility)
    const url = webhookId 
        ? `/api/guesty/webhook/${cosCustomerId}/${webhookId}` 
        : `/api/guesty/webhook/${cosCustomerId}`;
        
    return fetch(url, requestOptions);
}

export async function getGuestyWebhookMessages(cosCustomerId = null) {
    let url = "/goapi/guesty/webhook-messages";
    
    if (cosCustomerId) {
        url += `?cosCustomerId=${cosCustomerId}`;
    }
    
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch(url, requestOptions);
}

export async function getGuestyWebhookMessageById(id) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch(`/api/guesty/webhook-messages/${id}`, requestOptions);
}

export async function getGuestyRawWebhookMessageById(id) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch(`/api/guesty/webhook-messages/raw/${id}`, requestOptions);
}

export async function getGuestyFailedMessagesCount() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch("/api/guesty/webhook-messages/failed/count", requestOptions);
}

export async function toggleGuestyMessageStatus(id, forceStatus = null) {
    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow'
    };

    // If forceStatus is provided, add it to the request body
    if (forceStatus) {
        requestOptions.body = JSON.stringify({ targetStatus: forceStatus });
        requestOptions.headers.append("Content-Type", "application/json");
    }

    return fetch(`/api/guesty/webhook-messages/${id}/toggle-status`, requestOptions);
}

export async function getAllCustomers() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch("/api/user/customers", requestOptions);
}

export async function login(username, password, token) {

    let loginheaders = new Headers();
    loginheaders.append("Content-Type", "application/json");
    loginheaders.append('X-Recaptcha-Token', token)

    let requestOptions = {
        method: 'POST', headers: loginheaders,
        body: JSON.stringify({
            username: username,
            password: password
        })
    };

    return fetch("/api/login", requestOptions)
}

export async function getAllUsers() {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };

    return fetch("/api/user/all", requestOptions)
}

export async function getFieldWorkers() {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };

    return fetch("/api/worker/fieldworkers", requestOptions)
}

export async function getSuperVisor() {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };

    return fetch("/api/supervisor/all", requestOptions)
}

export async function getUserbyUsername(username) {

    let myHeaders = getheaders();

    let requestOptions = {
        method: 'GET', headers: myHeaders, redirect: 'follow'
    };

    return fetch("/api/user/" + username, requestOptions)
}

export async function changeUserDetail(username, userdetails) {

    let requestOptions = {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(userdetails)
    };

    return fetch("/api/user/" + username, requestOptions)
}

export async function getAllowedRegion() {

    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };

    return fetch("/api/user/allowedRegion", requestOptions)
}

export async function addNewUser(userdetails) {

    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(userdetails)
    };

    return fetch("/api/user", requestOptions)
}

export async function updateWebhookFilterMode(webhookId, filterMode) {
    let requestOptions = {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify({ filter_mode: filterMode })
    };

    return fetch(`/api/guesty/webhook/filter_mode/${webhookId}`, requestOptions);
}
